import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.brown.main,
    height: 80,
    flexDirection: 'row',
    alignItems: ({ isDeviceMdSize }) => (isDeviceMdSize ? 'center' : 'flex-end'),
    paddingBottom: ({ isDeviceMdSize }) => (isDeviceMdSize ? 16 : '8px !important'),
    width: ({ isDeviceMdSize }) => (isDeviceMdSize && '100%'),

    '& p': {
      position: 'relative',
      top: ({ isDeviceMdSize }) => !isDeviceMdSize && 3,
      fontSize: ({ isDeviceMdSize }) => (isDeviceMdSize ? 14 : 20),
      margin: '0 10px',
    },
  },
}));

export default useStyles;
